import { METRICS_IDENTIFY, METRICS_EVENT_MANUAL } from './actions';

// To create the action
export const makeMetricsLogEvent = (
  eventName,
  interactionData = {},
  immediate = false,
  options = {}
) => ({
  type: METRICS_EVENT_MANUAL,
  eventName,
  interactionData,
  immediate,
  options,
});

// To create the action
export const makeMetricsIdentify = (user, traits) => ({
  type: METRICS_IDENTIFY,
  user,
  traits,
});
